import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const getAuthToken = () => {
  const path = window.location.pathname;

  return path.startsWith("/lkart/admin")
    ? localStorage.getItem("admin_auth_token")
    : path.startsWith("/lkart/superadmin")
      ? localStorage.getItem("superadmintoken")
      : path.startsWith("/lkart/dashboard")
        ? localStorage.getItem("worker_auth_token")
        : null;
};

const getAuthHeaders = () => {
  const token = getAuthToken();
  return {
    "Content-Type": "application/json",
    ...(token && { Authorization: `Bearer ${token}` }),
  };
};

const useBankDetailsApi = () => {
  const fetchBankDetails = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/lenskart/account-details`, {
        headers: getAuthHeaders(),
      });
      return response.data;
    } catch (error) {
      console.error("Failed to fetch bank details:", error);
      throw error;
    }
  };

  const updateBankDetails = async (bankDetails, hasExisting = false) => {
    const method = hasExisting ? "put" : "post";
    try {
      const response = await axios[method](
        `${BASE_URL}/lenskart/account-details`,
        bankDetails,
        { headers: getAuthHeaders() }
      );

      // Backend returned HTTP 200 but with success: false
      if (response.data && response.data.success === false) {
        const serverMessage =
          response.data.message ||
          response.data.error ||
          response.data.details ||
          "Failed to update bank details";
        const err = new Error(serverMessage);
        err.response = response;
        err.isApiFailure = true;
        throw err;
      }

      return response.data;
    } catch (error) {
      if (error.isApiFailure) throw error;

      const serverMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.response?.data?.details ||
        error?.message ||
        "Failed to update bank details";

      const normalized = new Error(serverMessage);
      normalized.response = error.response;
      normalized.original = error;
      throw normalized;
    }
  };

  return { fetchBankDetails, updateBankDetails };
};

export default useBankDetailsApi;